export const formatAttendanceDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatCpf = (cpf) => {
  const digits = String(cpf || "").replace(/\D/g, "");
  if (digits.length !== 11) return cpf || "—";
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};

export const formatFileSize = (bytes) => {
  const size = Number(bytes) || 0;
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatUserName = (user) => {
  if (!user) return "";
  if (typeof user === "string") return user;
  const fullName = `${user.first_name || ""} ${user.last_name || ""}`.trim();
  return fullName || user.username || user.user_name || "";
};

export const ACCEPTED_ATTENDANCE_FILES =
  ".pdf,.jpg,.jpeg,.png,.gif,.webp,.bmp,.doc,.docx,.xls,.xlsx,.odt,.ods,.txt,.csv,application/pdf,image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const ATTENDANCE_STATUSES = [
  { value: "A_INICIAR", label: "A iniciar" },
  { value: "EM_ANDAMENTO", label: "Em andamento" },
  { value: "CONCLUIDO", label: "Concluído" },
  { value: "CANCELADO", label: "Cancelado" },
];

export const OPEN_ATTENDANCE_STATUSES = ["A_INICIAR", "EM_ANDAMENTO"];

export const isAttendanceOpen = (status) => OPEN_ATTENDANCE_STATUSES.includes(status);

export const getAttendanceStatusChipColor = (status) => {
  if (status === "A_INICIAR") return "warning";
  if (status === "EM_ANDAMENTO") return "info";
  if (status === "CONCLUIDO") return "success";
  if (status === "CANCELADO") return "error";
  return "default";
};
